import { createSlice } from '@reduxjs/toolkit';
import { post } from '../api/api';
import { dispatch } from '../../store';

type GeomanState = {
  isLoading: boolean,
  error: Error | string | null;
  mapChange: any,
  layerChange: any,
  perimeter: string | null,
  area: string | null,
  areaLong: string | null,
  liquidArea: any,
  liquidPercentage: any,
  condArea: any,
  pluscode: string | null,
  infosModal: any | null,
  socialLayer: string,
  glebaLayerId: any,
  loading3d: boolean,
  infosRhino: {
    distanciaTopo: any,
    bearing: any,
    distancia: any,
    angulosTopo: any,
    alturasTopo: any
  },
  alreadyMarked: boolean,
  polarCoords: any,
  latLongs: any,
  address: any,
  loadingRestrictionPromises: boolean,
  max300HaModal: boolean
};

const initialState: GeomanState = {
  isLoading: false,
  error: null,
  mapChange: null,
  layerChange: null,
  perimeter: null,
  area: null,
  areaLong: null,
  liquidArea: 0,
  liquidPercentage: 0,
  condArea: null,
  pluscode: null,
  infosModal: null,
  socialLayer: "classe",
  glebaLayerId: null,
  loading3d: true,
  infosRhino: {
    distanciaTopo: null,
    bearing: null,
    distancia: null,
    angulosTopo: null,
    alturasTopo: null
  },
  alreadyMarked: false,
  polarCoords: null,
  latLongs: [],
  address: null,
  loadingRestrictionPromises: false,
  max300HaModal: false,
};

const slice = createSlice({
  name: 'geoman',
  initialState,
  reducers: {
    resetGeomanState(state) {
      state = {
        isLoading: false,
        error: null,
        mapChange: null,
        layerChange: null,
        perimeter: null,
        area: null,
        areaLong: null,
        liquidArea: 0,
        liquidPercentage: 0,
        condArea: null,
        pluscode: null,
        infosModal: null,
        socialLayer: "classe",
        glebaLayerId: null,
        loading3d: true,
        infosRhino: {
          distanciaTopo: null,
          bearing: null,
          distancia: null,
          angulosTopo: null,
          alturasTopo: null
        },
        alreadyMarked: false,
        polarCoords: null,
        latLongs: [],
        address: null,
        loadingRestrictionPromises: false,
        max300HaModal: false
      }
    },
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setMapChange(state, action) {
      state.mapChange = action.payload;
    },
    setLayerChange(state, action) {
      state.layerChange = action.payload;
    },
    setSocialLayer(state, action) {
      state.socialLayer = action.payload;
    },
    setPerimeter(state, action) {
      state.perimeter = action.payload;
    },
    setArea(state, action) {
      state.area = action.payload;
    },
    setAreaLong(state, action) {
      state.areaLong = action.payload;
    },
    setLiquidArea(state, action) {
      state.liquidArea = action.payload;
    },
    setLiquidPercentage(state, action) {
      state.liquidPercentage = action.payload;
    },
    setCondArea(state, action) {
      state.condArea = action.payload;
    },
    setGlebaLayerId(state, action) {
      state.glebaLayerId = action.payload;
    },
    getPlusCodeSuccess(state, action) {
      state.pluscode = action.payload;
    },
    getInfosModalSuccess(state, action) {
      state.infosModal = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setLoading3d(state, action) {
      state.loading3d = action.payload;
    },
    setInfosRhino(state, action) {
      state.infosRhino = action.payload
    },
    setAlreadyMarked(state, action) {
      state.alreadyMarked = action.payload;
    },
    resetInfosModal(state, action) {
      state.infosModal = null;
    },
    savePolarCoords(state, action) {
      state.polarCoords = action.payload
    },
    saveLatLongs(state, action) {
      state.latLongs = action.payload
    },
    setAddress(state, action) {
      state.address = action.payload
    },
    setLoadingRestrictionPromises(state, action) {
      state.loadingRestrictionPromises = action.payload;
    },
    setMax300HaModal(state, action) {
      state.max300HaModal = action.payload
    }
  },
});

// Reducer
export default slice.reducer;
export const { setMax300HaModal, setMapChange, setLayerChange, setPerimeter, setArea, setAreaLong, setLiquidArea, setLiquidPercentage, setSocialLayer, setGlebaLayerId, setLoading, setInfosRhino, setLoading3d, setAlreadyMarked, resetInfosModal, setCondArea, savePolarCoords, saveLatLongs, setAddress, resetGeomanState, setLoadingRestrictionPromises } = slice.actions;

export function getAddress(lat: any, lng: any) {
  return async () => {
    try {
      const address = await post('/map/getAddress', { lat, lng })
      dispatch(slice.actions.setAddress(address.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  }
}

export function getPlusCode(lat: any, lng: any) {
  return async () => {
    try {
      const pluscode = await post('/map/getPlusCode', { lat, lng })
      dispatch(slice.actions.getPlusCodeSuccess(pluscode.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInfosModal(lat: any, lng: any) {
  return async () => {
    try {
      const infos = await post('/map/getInfosModal', { lat, lng })
      dispatch(slice.actions.getInfosModalSuccess(infos.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function saveInfos(polar: any, latlng: any) {
  dispatch(slice.actions.savePolarCoords(polar));
  //dispatch(slice.actions.saveLatLongs(latlng));
}



